//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Mobile, PC } from "../../../../media/MediaQuery";

//css
import styled from "styled-components";
// component
import BasicBtn from "../../../../component/button/BasicBtn";
import RadioBox from "../../../../component/button/RadioBox";

// responsive
import { M, T } from "../../../../utils/MT";

export default function MemOutDetail({ setCompleteModal }) {
    //페이지 이동
    const navigate = useNavigate();
    const goBack = () => {
        navigate("/");
    };

    // textarea border 효과
    const [borderActive, setBorderActive] = useState(false);

    const ReasonList = [
        {
            id: "comeBack",
            text: "탈퇴 후 재가입을 위해서",
        },
        {
            id: "BadProduct",
            text: "상품다양성/가격/품질불만",
        },
        {
            id: "Badservice",
            text: "교환/환불/반품불만",
        },
        {
            id: "manyDm",
            text: "광고성 알림이 너무 많이 와서",
        },
        {
            id: "privacy",
            text: "개인정보유출우려",
        },
        {
            id: "notUse",
            text: "이용빈도낮음",
        },
        {
            id: "noBenefit",
            text: "실질적인혜택부족",
        },
    ];

    return (
        <Wrap>
            <TitleWrap>
                <Title>회원탈퇴</Title>
            </TitleWrap>
            <WhyOutWrap>
                <WhyOutText>탈퇴사유</WhyOutText>
                <OutReasonListWrap>
                    {ReasonList.map((list, index) => {
                        return (
                            <OutReasonList key={list.id}>
                                <RadioBox id={list.id} text={list.text} name="whyOut" defaultChecked={false} />
                            </OutReasonList>
                        );
                    })}
                </OutReasonListWrap>
                <TextArea
                    onChange={(e) => {
                        setBorderActive(e.target.value);
                    }}
                    active={borderActive.length > 0}
                    placeholder="의견을 작성해 주세요."
                ></TextArea>
            </WhyOutWrap>

            <BtnWrap>
                <BasicBtn
                    onClick={() => {
                        setCompleteModal(true);
                    }}
                    gray={true}
                    text="취소하기"
                />
                <BasicBtn
                    onClick={() => {
                        goBack();
                    }}
                    text="탈퇴"
                />
            </BtnWrap>
        </Wrap>
    );
}

const Wrap = styled.div`
    position: relative;
    width: 100%;

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: 0 auto;
    }
`;

const TitleWrap = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding-bottom: calc(100vw * (20 / 1920));
    margin-bottom: calc(100vw * (20 / 1920));
    border-bottom: 1px solid #000;

    @media screen and (max-width: 1300px) {
        padding-bottom: calc(100vw * (20 / 1300));
        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        padding-bottom: ${M(20)};
        margin-bottom: ${M(20)};
    }
`;

const Title = styled.h3`
    font-size: calc(100vw * (25 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (25 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};
    }
`;

const WhyOutWrap = styled.div`
    margin-bottom: calc(100vw * (60 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (60 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(60)};
    }
`;

const WhyOutText = styled.h4`
    font-size: calc(100vw * (20 / 1920));
    margin-bottom: calc(100vw * (20 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (20 / 1300));
        margin-bottom: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(16)};
        margin-bottom: ${M(20)};
    }
`;

const OutReasonListWrap = styled.ul`
    display: flex;
    flex-wrap: wrap;

    align-items: center;

    margin-bottom: calc(100vw * (28 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (28 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(28)};
    }
`;

const OutReasonList = styled.li`
    flex-shrink: 0;
    width: 25%;

    &:nth-child(n + 5) {
        margin-top: calc(100vw * (24 / 1920));

        @media screen and (max-width: 1300px) {
            margin-top: calc(100vw * (24 / 1300));
        }

        @media screen and (max-width: 900px) {
            margin-top: ${M(20)};
        }
    }

    @media screen and (max-width: 900px) {
        width: 50%;
        margin-top: ${M(20)};
    }
`;
const TextArea = styled.textarea`
    width: 100%;
    height: calc(100vw * (150 / 1920));
    font-size: calc(100vw * (15 / 1920));
    padding: calc(100vw * (20 / 1920));

    border-radius: 4px;

    background: #fafafa;

    @media screen and (max-width: 1300px) {
        height: calc(100vw * (150 / 1300));
        font-size: calc(100vw * (15 / 1300));
        padding: calc(100vw * (20 / 1300));
    }

    @media screen and (max-width: 900px) {
        height: ${M(150)};
        font-size: ${M(15)};
        padding: ${M(20)};
    }

    ${({ active }) => {
        return active
            ? `border: 1px solid var(--main-color);
         color: #222;
         background: #fff;
        `
            : `border: 1px solid #FAFAFA;`;
    }}
`;

const BtnWrap = styled.div`
    display: flex;
    justify-content: center;

    & > p {
        width: calc(100vw * (200 / 1920));
    }

    & > p:first-child {
        margin-right: calc(100vw * (19 / 1920));
    }

    @media screen and (max-width: 1300px) {
        & > p {
            width: calc(100vw * (200 / 1300));
        }

        & > p:first-child {
            margin-right: calc(100vw * (19 / 1300));
        }
    }

    @media screen and (max-width: 900px) {
        & > p {
            width: ${M(200)};
        }

        & > p:first-child {
            margin-right: ${M(19)};
        }
    }
`;
